const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-html-snippet'] = {
        c: () => require('partner/modules/hei-html-snippet/hei-html-snippet.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-html-snippet',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-html-snippet'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-html-snippet|hei-html-snippet'] = {
                c: () => require('partner/modules/hei-html-snippet/hei-html-snippet.view.tsx'),
                cn: '__local__-__local__-hei-html-snippet'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };